import React, { Component, location, history, useState } from 'react';
import { observer } from 'mobx-react/dist/mobx-react';
import { withFirestore } from 'react-firestore';
import {ColorPicker} from 'primereact/colorpicker';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import { Placeholder } from 'semantic-ui-react';

import InputColor from '../../helpers/ColorPicker/input-color';
import { joyRideStepSettings } from '../../helpers/joyrideHelpers/joyrideHelpers';

const Properties = observer(class Properties extends Component {



  state = {
    background: '#fff',
    panel: "object",
    isLoading: true,
    isLoadingEnv: true,
    objName: "",
    modifiers: [],
    preview: "",
    standardMods: undefined,
    initial: '#5e72e4',
    color: ''
  };



  // const [color, setColor] = React.useState({});

  downloadedElements = {};
  currentRotationCommand = undefined;
  firebaseRawData = {};


  updateObjectTransforms(type){
    this.currentRotationCommand = type;
    if(this.props.joyrideRunning){
      if(this.props.joyRideStepIndex === joyRideStepSettings.templateFlatlayProductId ){
        this.props.setJoyRideStepByIndex(joyRideStepSettings.templateFlatlayProductId + 1);
      }
    }

    this.unityContent.send("SceneRecreator", "sendSelectedObjectTransformationDataViaExternalFunction");
  }

  changeTransformTool(tool){
    // CameraController -> OnToolChanged(tool). Mögliche Parameter: ‘Rotate’, ‘Move’, ‘None’, ‘Scale’, ‘View’
    this.unityContent.send("CameraController", "OnToolChanged", tool);
    this.props.handleTransforms(tool);
  }


  updateObject(){
    console.log('UNITY MODIFIERS: CURR UPDATE OBJ', this.props.selectedObj.modifiers);

    this.setState({ isLoading: true, modifiers: [] });
    console.log("downloadedElements: ", this.downloadedElements);
    if (this.firebaseRawData[this.props.selectedObj.firebaseId]) {
      console.log('this element has already been downloaded, load from store');
      var currObjectData =  this.firebaseRawData[this.props.selectedObj.firebaseId];
      currObjectData.modifiers = this.createModifierForObj(this.props.selectedObj.modifiers, currObjectData.modifiers);
      this.downloadedElements[this.props.selectedObj.firebaseId] = currObjectData;
      this.setCurrObjectData(this.props.selectedObj.firebaseId);
    } else {
      const { firestore } = this.props;
      const currentCollection = this.props.selectedObj.type == "obj" ? "Objects" : "Products";
      firestore.doc(currentCollection + '/' + this.props.selectedObj.firebaseId).onSnapshot(snapshot => {
        var currObjectData = snapshot.data();
        this.firebaseRawData[this.props.selectedObj.firebaseId] = currObjectData;
          currObjectData.modifiers = this.createModifierForObj(this.props.selectedObj.modifiers, currObjectData.modifiers);
        console.log('Information About OBJ: ', snapshot.data());
        this.downloadedElements[this.props.selectedObj.firebaseId] = currObjectData;

        // this.updateRecommendedColorsOfModifiers(this.state.modifiers, currObjectData.modifiers);

        this.setCurrObjectData(this.props.selectedObj.firebaseId);
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedObj !== this.props.selectedObj) {
      this.updateObject();
    }
  }


  componentDidMount(){
    this.updateObject();
  }

  createJavascriptModifier(modifiers){
    var javascriptModifiers = [];
    for (var i = 0; i<modifiers.length; i++){
      modifiers[i].options = this.modifierOptionsToProperties(modifiers[i].options);
      javascriptModifiers.push(modifiers[i]);
    }
    return javascriptModifiers;
  }

  modifierOptionsToProperties(options){
    var returnOption = {};
    if(Array.isArray(options)){
      for(var i = 0; i<options.length; i++){
        const currOption = options[i].split("=");
        returnOption[currOption[0]] = currOption[1];
      }
    }else{
      returnOption = options;
    }

    return returnOption;
  }

  createModifierForObj(unityModifiers, firebaseModifiers){
    console.log('UNITY MODS: BEFORE:', JSON.stringify(unityModifiers));
    firebaseModifiers = this.createJavascriptModifier(firebaseModifiers || []);
    unityModifiers = this.createJavascriptModifier(unityModifiers || []);


    console.log('UNITY MODS: ', JSON.stringify(unityModifiers));
    for (var i = 0; i<firebaseModifiers.length; i++){
      if(firebaseModifiers[i].type === "materialEdit"){
        for (var j = 0; j<unityModifiers.length; j++){
          if(firebaseModifiers[i].options.materialName === unityModifiers[j].options.materialName){
            unityModifiers[j].modifierViewerText = firebaseModifiers[i].modifierViewerText || "";
            if(!unityModifiers[j].options.defaultColor){
              // unityModifiers[j].options.defaultColor = firebaseModifiers[i].options.defaultColor;
            }
          }
          if(unityModifiers[j].type === firebaseModifiers[i].type === "materialEdit" && unityModifiers[j].options.materialName === firebaseModifiers[i].options.materialName && unityModifiers[j].options.materialName !== undefined){
            unityModifiers[j].colorRec = firebaseModifiers[i].colorRec || [];
          }
        }
      }
    }

    return unityModifiers;
  }


  // TODO: update rec colors only  --> put this back in update OBJ - we shouldn't see a color moving anymore
  updateRecommendedColorsOfModifiers(oldModifiers, newModifiers){
    oldModifiers = this.createJavascriptModifier(oldModifiers);
    newModifiers = this.createJavascriptModifier(newModifiers);
    oldModifiers.forEach( (oldModifier) => {
      newModifiers.forEach( (newModifier) => {
        if(oldModifier.type === newModifier.type === "materialEdit" && oldModifier.options.materialName === newModifier.options.materialName && oldModifier.options.materialName !== undefined){
          oldModifier.colorRec = newModifier.colorRec || [];
        }
      });
    });


  }

  setCurrObjectData(firebaseId){
    const currMod = this.state.standardMods ? this.state.standardMods :  this.downloadedElements[firebaseId].modifiers.map(a => a.options.defaultColor);;

    console.log(`MODS: ${JSON.stringify(this.downloadedElements[firebaseId].modifiers)}`);
    this.setState({
      objName: this.downloadedElements[firebaseId].name,
      preview: this.downloadedElements[firebaseId].preview,
      modifiers: this.downloadedElements[firebaseId].modifiers,
      isLoading: false,
      standardMods: currMod || []
    });
  }

  handleChangeComplete(color, i) {

    var newModifiers = this.state.modifiers;
    console.log('state modifiers: ', this.state.modifiers);
    newModifiers[i].options.defaultColor = color.hex;
    this.setState({ modifiers: newModifiers, color: color });

    if(this.state.modifiers[i].type === "materialEdit"){
      // todo create for all modifiers
      var currModifiers = [
        {
          "type": this.state.modifiers[i].type,
          "options": ["materialName="+this.state.modifiers[i].options.materialName, "isColorChangeable="+this.state.modifiers[i].options.isColorChangeable,"defaultColor=" + color.hex]
        }
      ];

      this.unityContent.send('ModifierManager', 'applyModifierToSelectedObject', JSON.stringify(currModifiers));
    }

  };


  constructor(props) {
    super(props);
    this.unityContent = this.props.unityContent;
    this.handleChangeComplete = this.handleChangeComplete.bind(this);

    // this.unityContent.on("onUserHasInteractionToolChanged", (argument) => {
    //   // console.log('TOOL CHANGED: ', argument);
    //   this.changeTransformTool(argument)
    // });

    // this is used to reset the rotation and to flip it
    this.unityContent.on("selectedObjectsTransformationData", (data) => {
      let dataArray = data.split(',');
      var currentTransforms = {
        rotation: {
          x: dataArray[3],
          y: dataArray[4],
          z: dataArray[5]
        },
        move: {
          x: dataArray[0],
          y: dataArray[1],
          z: dataArray[2]
        },
        scale: {
          x: dataArray[6],
          y: dataArray[7],
          z: dataArray[8]
        }
      };

      if(this.currentRotationCommand === "resetRotation" || this.currentRotationCommand === "flipUp") {
        if (this.currentRotationCommand === "resetRotation") {
          currentTransforms.rotation.x = 0;
          currentTransforms.rotation.y = 0;
          currentTransforms.rotation.z = 0;
        } else if (this.currentRotationCommand === "flipUp") {
          currentTransforms.rotation.x = -90;
          currentTransforms.rotation.y = 0;
          currentTransforms.rotation.z = 0;
        }

        const currTransforms = `${currentTransforms.move.x}, ${currentTransforms.move.y}, ${currentTransforms.move.z}, ${currentTransforms.rotation.x}, ${currentTransforms.rotation.y}, ${currentTransforms.rotation.z}, ${currentTransforms.scale.x}, ${currentTransforms.scale.y}, ${currentTransforms.scale.z}`
        this.unityContent.send("SceneRecreator", "setPositionRotationScaleForSelectedObject", currTransforms);
      }


      this.currentRotationCommand = undefined;

    });

  }


  render() {
    return (
      <div className="object-panel-viewer">
            {
              this.state.isLoading ?
              (
                <>
                  <div className="object-name-container">
                    <Placeholder.Line/>
                  </div>
                  <div className="object-modifier-container">
                    <div className="placeholder-container">
                      <Placeholder>
                        <Placeholder.Header/>
                        <Placeholder.Line/>
                        <Placeholder.Line/>
                      </Placeholder>
                    </div>
                  </div>
                </>
              )
              :
              (
                <>
                  <div className="object-name-container">
                    <img src={this.state ? this.state.preview : ""} alt="" className="object-prev-container" />
                    <h3 className="object-name">{this.state.objName}</h3>
                  </div>
                  <div className="object-modifier-container" onClick={() => {this.props.unityContent.send('Network', 'focusCanvas', "0"); }}>
                    <div className={"modifierContainer"}>
                      {this.state.modifiers.map((modifier, i) => {
                        return (
                          <div className={"modifierContainer"}>
                            {(modifier.type === "materialEdit" && modifier.options.isColorChangeable === "true") && (
                            <InputColor title={modifier.modifierViewerText  || ("Material" + (i+1) )}
                                        initialHexColor={modifier.options.defaultColor || "#fff"}
                                        onChange={ (color) => (this.handleChangeComplete(color, i)) }
                                        recommendColors={[].concat(modifier.colorRec).concat(this.props.reccomendedColorsGlobally)}
                                        selectionId={this.props.selectionId}
                                        key={this.props.selectionId + modifier.modifierViewerText}
                            />
                            )}
                          </div>

                        );
                      })}
                    </div>

                <div className={"div-block-54"}></div>
                <div className="object-controls-container">
                  <div className={"text-block-51"}>Orientation</div>
                  <div className={"max-space"}></div>
                  <div className="single-control-container-2 no-grow rounded" onClick={() => {this.updateObjectTransforms("resetRotation")}}>
                    <div className="html-embed-5 w-embed">
                      <span dangerouslySetInnerHTML={{__html: "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M83.9,60.8c2.2,2.2,2.2,5.9,0,8.1c-1.1,1.1-2.6,1.7-4.1,1.7s-2.9-0.6-4.1-1.7L50,43.2L24.3,69c-2.2,2.2-5.9,2.2-8.1,0  c-2.2-2.2-2.2-5.9,0-8.1L45.9,31c2.2-2.2,5.9-2.2,8.1,0L83.9,60.8z\"></path></svg>"}} />
                    </div>
                  </div>
                  <div className="single-control-container-2 no-grow rounded" onClick={() => {this.updateObjectTransforms("flipUp")}}>
                    <div className="html-embed-5 w-embed">
                      <span dangerouslySetInnerHTML={{__html: "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M69,45.9c1.1,1.1,1.7,2.5,1.7,4.1c0,1.5-0.6,3-1.7,4.1L39.2,83.9c-1.1,1.1-2.6,1.7-4.1,1.7S32.1,85,31,83.9  c-2.2-2.2-2.2-5.9,0-8.1L56.8,50L31,24.3c-2.2-2.2-2.2-5.9,0-8.1c2.2-2.2,5.9-2.2,8.1,0L69,45.9z\"></path></svg>"}} />

                    </div>
                  </div>
                </div>
                <div className="object-controls-container">
                  <div className={"text-block-51"}>Tools</div>
                  <div className={"single-control-container-2 left "  + (this.props.transformTool === "Move" ? "active" : "")} onClick={() => this.changeTransformTool("Move")}>
                    <div className="html-embed-5 w-embed">
              <span dangerouslySetInnerHTML={{__html: "<svg fill=\"currentColor\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\"\n" +
                "                   xmlns:cc=\"http://creativecommons.org/ns#\" xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"\n" +
                "                   xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\"\n" +
                "                   xmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\"\n" +
                "                   xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\" viewBox=\"0 0 1225.3125 1225\"\n" +
                "                   version=\"1.1\" x=\"0px\" y=\"0px\">\n" +
                "                <g transform=\"translate(2744.9592,686.01217)\">\n" +
                "                  <path style=\"\"\n" +
                "                        d=\"m -2250.6863,421.91658 c -64.3951,-64.38924 -117.082,-117.40807 -117.082,-117.81961 0,-1.3009 81.8294,-82.60907 83.1386,-82.60907 0.6873,0 21.1804,19.93669 45.5402,44.30374 24.3598,24.36707 44.7475,44.02137 45.3059,43.67624 1.224,-0.7565 1.3346,-151.83751 0.1844,-252.04249 l -0.8286,-72.18751 -161.0452,0 c -88.5749,0 -161.0453,0.41899 -161.0453,0.93108 0,0.5121 20.1064,21.0432398 44.6808,45.62477 l 44.6807,44.69367 -41.863,41.87701 c -23.0246,23.03234 -42.3473,41.71554 -42.9393,41.51821 -2.1204,-0.70681 -233.3544,-232.63411 -232.9997,-233.6983 0.1994,-0.59803 52.9331,-53.66084 117.1862,-117.91739 l 116.8237,-116.83007 41.8984,41.8984 41.8984,41.89841 -44.6831,44.69603 c -24.5757,24.58281 -44.6831,45.115 -44.6831,45.6271 0,0.51209 72.4704,0.93108 161.0453,0.93108 l 161.0453,0 0.8297,-71.45589 c 1.1512,-99.14034 1.0393,-250.76709 -0.1857,-251.52415 -0.5584,-0.34515 -20.6648,19.0279 -44.6808,43.05124 -24.0159,24.02333 -44.2341,43.67878 -44.9292,43.67878 -1.6166,0 -83.8301,-82.18747 -83.0689,-83.0427 3.9825,-4.47493 233.1322,-233.20733 233.6327,-233.20733 0.3804,0 53.002,52.3126 116.9368,116.2501 l 116.245,116.25012 -42.1829,42.18294 -42.183,42.18295 -44.0711,-44.05805 c -24.2391,-24.23193 -44.4922,-44.05804 -45.0069,-44.05804 -0.5146,0 -0.7929,72.70313 -0.6184,161.56251 l 0.3172,161.56252 162.1875,0.31717 c 89.2031,0.17445 162.1875,-0.10387 162.1875,-0.61857 0,-0.51467 -19.9689,-20.91042 -44.3753,-45.3239 l -44.3753,-44.38814 41.8784,-41.86438 41.8783,-41.86437 117.1828,117.18276 117.1827,117.18274 -116.2458,116.25086 c -63.9352,63.93797 -116.8126,116.25085 -117.5053,116.25085 -0.6927,0 -19.9594,-18.70619 -42.8149,-41.56931 l -41.5554,-41.56929 43.7499,-43.73651 c 24.0624,-24.0550802 43.7499,-44.44477 43.7499,-45.31041 0,-1.25871 -32.354,-1.51037 -161.5625,-1.2567 l -161.5625,0.3172 -0.3172,162.18752 c -0.1745,89.20313 0.1039,162.18751 0.6186,162.18751 0.5146,0 21.0489,-20.10739 45.6317,-44.68309 l 44.6961,-44.68309 42.183,42.18299 42.1829,42.183 -116.87,116.8751 c -64.2786,64.28132 -117.2,116.87511 -117.6031,116.87511 -0.4032,0 -53.42,-52.68211 -117.8151,-117.07135 z\"\n" +
                "                        fill=\"currentColor\"></path>\n" +
                "                </g>\n" +
                "              </svg>"}} />

                    </div>
                  </div>
                  <div className={"single-control-container-2 "   + (this.props.transformTool === "Rotate" ? "active" : "")} onClick={() => this.changeTransformTool("Rotate")}>
                    <div className="html-embed-5 w-embed">
              <span dangerouslySetInnerHTML={{__html: "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" x=\"0px\" y=\"0px\">\n" +
                "                <title>rotate-turning-refresh</title>\n" +
                "                <g data-name=\"Layer 31\">\n" +
                "                  <path\n" +
                "                    d=\"M14.64,28.93A13,13,0,0,1,17.36,3.07,12.91,12.91,0,0,1,24.6,6.27l-2.66.19.14,2,6-.42-.42-6-2,.14.17,2.49A15,15,0,0,0,4.34,25.44a14.9,14.9,0,0,0,10.09,5.48A15.28,15.28,0,0,0,16,31a14.94,14.94,0,0,0,9.42-3.34L24.18,26.1A12.94,12.94,0,0,1,14.64,28.93Z\"></path>\n" +
                "                  <circle cx=\"16\" cy=\"16\" r=\"5\"></circle>\n" +
                "                </g>\n" +
                "              </svg>"}} />

                    </div>
                  </div>
                  <div className={"single-control-container-2 right "  + (this.props.transformTool === "Scale" ? "active" : "")} onClick={() => this.changeTransformTool("Scale")}>
                    <div className="html-embed-5 w-embed">
              <span dangerouslySetInnerHTML={{__html: "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Слой 3\"\n" +
                "                   viewBox=\"0 0 140.82477 140.82477\" x=\"0px\" y=\"0px\"><title>17</title>\n" +
                "                <path\n" +
                "                  d=\"M213.53866,79.58762l-63.8846.00118a6.87373,6.87373,0,0,0,0,13.74746h47.28773l-37.04716,37.04715a21.446,21.446,0,0,1,6.465,4.47217,21.72451,21.72451,0,0,1,3.67006,4.83665l36.634-36.634v47.28773a6.87373,6.87373,0,1,0,13.74746,0l.00118-63.8846a6.872,6.872,0,0,0-6.87372-6.87372Z\"\n" +
                "                  transform=\"translate(-79.58762 -79.58762)\"></path>\n" +
                "                <path\n" +
                "                  d=\"M93.33611,196.94193l-.001-47.28668a6.87373,6.87373,0,1,0-13.74745,0v63.88341a6.87194,6.87194,0,0,0,6.87372,6.87372h63.88341a6.87373,6.87373,0,1,0,0-13.74745l-47.28668-.001,36.542-36.542a21.7246,21.7246,0,0,1-4.8368-3.66991,21.446,21.446,0,0,1-4.472-6.46519Z\"\n" +
                "                  transform=\"translate(-79.58762 -79.58762)\"></path>\n" +
                "                <path\n" +
                "                  d=\"M147.74218,142.53586a8.56632,8.56632,0,0,0-3.25692,2.04168,8.41628,8.41628,0,0,0-2.01719,3.23244,8.59312,8.59312,0,0,0,7.99625,11.44766,8.63119,8.63119,0,0,0,8.70119-8.7012,8.60949,8.60949,0,0,0-11.42333-8.02058Z\"\n" +
                "                  transform=\"translate(-79.58762 -79.58762)\"></path>\n" +
                "              </svg>"}} />

                    </div>
                  </div>
                </div>
                <div className={"div-block-54"}></div>
                <div className="delete-obj-control-container">
                  <div className="max-space"></div>
                  <div className="delete-button-object-2" onClick={ () => { this.props.onPress("Delete Selection")}} >
                    <div className="svg-inherit delete w-embed">
              <span dangerouslySetInnerHTML={{__html: "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\"><path d=\"M88.6,50c0-21.3-17.3-38.6-38.6-38.6S11.4,28.7,11.4,50S28.7,88.6,50,88.6S88.6,71.3,88.6,50z M38.3,67.7l-6-6L44,50  L32.3,38.3l6-6L50,44l11.7-11.7l6,6L56,50l11.7,11.7l-6,6L50,56L38.3,67.7z\"></path></svg>\n" +
                "            "}} />
                    </div>
                    <div className="delete-button-obj-text">Delete Object</div>
                  </div>
                </div>
                  </div>
                </>
              )
            }


          {/*<div className="single-object-modifier-container">*/}
            {/*<div className="text-block-48">Material</div>*/}
            {/*<div className="material-container">*/}
              {/*<div className="single-material-container"><img src="images/regular_marble.jpg" alt=""*/}
                                                              {/*className="material-preview active" />*/}
                {/*<div className="material-name">Regular Marble</div>*/}
              {/*</div>*/}
              {/*<div className="single-material-container"><img src="images/pink_marble_tiles.jpg" alt=""*/}
                                                              {/*className="material-preview" />*/}
                {/*<div className="material-name">Regular Marble</div>*/}
              {/*</div>*/}
              {/*<div className="single-material-container"><img src="images/japanese_house_wooden_floor.jpg" alt=""*/}
                                                              {/*className="material-preview" />*/}
                {/*<div className="material-name">Regular Marble</div>*/}
              {/*</div>*/}
              {/*<div className="single-material-container"><img src="images/basket_wave_parquet.jpg" alt=""*/}
                                                              {/*className="material-preview" />*/}
                {/*<div className="material-name">Regular Marble</div>*/}
              {/*</div>*/}
              {/*<div className="single-material-container"><img src="images/basket_wave_parquet.jpg" alt=""*/}
                                                              {/*className="material-preview" />*/}
                {/*<div className="material-name">Regular Marble</div>*/}
              {/*</div>*/}
              {/*<div className="single-material-container"><img src="images/basket_wave_parquet.jpg" alt=""*/}
                                                              {/*className="material-preview" />*/}
                {/*<div className="material-name">Regular Marble</div>*/}
              {/*</div>*/}
            {/*</div>*/}
          {/*</div>*/}

      </div>
    );
  }
});


export default withFirestore(Properties);


